import styled from 'styled-components'

export const ContentWrapper = styled.div`
  max-width: 640px;
  flex: 1;
  margin-top: 24px;
`
